import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@store/modules/auth'
import user from '@store/modules/user'
import restaurant from '@store/modules/restaurant'
import branch from '@store/modules/branch'
import promotion from '@store/modules/promotion'
import coupon from '@store/modules/coupon'
import history from '@store/modules/history'
import bill from '@store/modules/bill'
import feedback from '@store/modules/feedback'
import membership from '@store/modules/membership'
import i18n from '@/helper/i18n'
import { convertAliaseHandler } from "@/api/api"
import { MessageBox, Loading } from 'element-ui'
import router from '../router'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    restaurant,
    branch,
    promotion,
    coupon,
    history,
    bill,
    feedback,
    membership
  },
  state: {
    aliaseDetail: null,
  },
  mutations: {
    SET_ALIASE_DETAIL(state, data) {
      state.aliaseDetail = data;
    },
  },
  actions: {
    async convertAliase({ state, commit }, payload) {
      try {
        state.loading = Loading.service();
        const response = await convertAliaseHandler(payload);
        commit('SET_ALIASE_DETAIL', response.data.data);
        return response.data.data;
      } catch (error) {
        if (error.response) {
          if (error.response.status == 404) {
            router.push({
              name: "NotFound",
            });
          }
        }

        await MessageBox.alert(
          `${i18n.t('store.error-restaurant-code')}
          <br>${i18n.t('store.try-again-later')}
          <br>${error.toJSON().message}`,
          i18n.t('store.mistake'),
          { dangerouslyUseHTMLString: true },
        )
          .finally(() => {
            window.location.reload();
          });
      } finally {
        state.loading.close();
      }
    },
  },
})
export default store
